const _none = "none"
const _disc = "disc"
const _decimal = "decimal"
const config = { "none": _none, "disc": _disc, "decimal": _decimal,  }
export { config as default, _none, _disc, _decimal }